import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';
import CircularProgress from 'material-ui/CircularProgress';
import Header from '../Components/Header/HeaderSmall';

const optionsContainerPaper = {
   minWidth: 300,
   width:'auto',
   textAlign: 'center'
};


class ConfirmationPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {  
       
        provider: null,
        facility: null,
        fetchingProvider: false,
        fetchingFacility: false
    };
  }


    componentDidMount() {

        this.loadProvider(this.props.params.providerId);
    }

     loadProvider(providerId) {
        var self = this;

        self.setState({fetching: true});

        let config = {
            method: 'get',
            url: `provider/${providerId}`
        };

       resourceApi(config) 
            .then(function (response) {
                console.log(response);
                
                self.setState({ provider: response.data });
                // going to make this one call now. 
                //self.loadDocDetails();

                //self.setState({fetchingProvider: false});

                self.loadFacility(self.props.params.facilityId);

                //self.setState({ message: response.data.message });
            })
            .catch(function (error) {
                console.log(error);
                self.setState({fetchingProvider: false});
            });
    }


  loadFacility(facilityId) {
        var self = this;

        //self.setState({fetchingFacility: true});
       let config = {
            method: 'get',
            url: `provider/${facilityId}`
        };

       resourceApi(config) //this.state.episode.PhysicianID
            .then(function (response) {
                console.log(response);
                
                self.setState({ facility: response.data });

                self.setState({fetching: false});
                //self.setState({ message: response.data.message });
            })
            .catch(function (error) {
                console.log(error);
                self.setState({fetching: false});
            });
    }

    render() {

      const { router } = this.props

    return (
         <div>
           <Header router={ router } title="Summary">
               {/*<SelectionStepper activeStep={3} />*/}
            </Header>
               <br />

                {(this.state.fetching) && (
                    <div className="loader" >
                        <CircularProgress />
                    </div>
                )}
                

                {(!this.state.fetching) && (
               <div className="container"  >

                    <Paper zDepth={1} style={optionsContainerPaper} >
                        <div className="container">
                            <h3>What do I do now?</h3>
                                <ul className="list-text">
                                    <li>Call the doctor using the call button below to set up your appointment.</li>
                                    <li>Remember to let them know which hospital, clinic, or surgery facility you’ve chosen!</li>
                                    <li>The doctor may or may not be aware of the cost estimate. If they aren’t, no problem.</li>
                                </ul>
                        </div>
                    </Paper>
                    <Paper style={optionsContainerPaper} zDepth={1} >
                        <div className="container" >
                            <h3>Schedule Appointment</h3>
                            <RaisedButton label="Call" primary={true} labelStyle={{fontSize:26}} style={{height:40, width:200, margin:10}} />
                        </div>
                    </Paper>
                   <Paper zDepth={1} >
                         <div className="container">
                             <table>
                                 <tr>
                                    <td style={{width: 220}}>
                                        <h4>Estimated Cost</h4>
                                    </td>
                                    <td>
                                        <h3>{(this.props.params.cost) ? "$" + Math.round(this.props.params.cost) : ""}</h3>
                                    </td>   
                                </tr>
                            </table>
                        </div>
                    </Paper>
                   <Paper>
                        <div className="container"  >
                       <h4>Your Facility</h4>
                        {(this.state.facility) && (
                            <div>
                                <h5>{this.state.provider.ProviderAlias || this.state.facility.OrganizationName}</h5>
                                <span>{ this.state.facility.Address1 + " " + this.state.facility.Address2 }</span><br />
                                <span>{ this.state.facility.City + ", " + this.state.facility.State + " " + this.state.facility.ZipCode }</span>
                            </div>
                        )}
                        </div>
                    </Paper>
                    <Paper>
                         <div className="container"  >
                        <h4>Your Doctor</h4>
                        {(this.state.provider) && (
                            <div>
                                <h5>{this.state.provider.ProviderAlias || this.state.provider.FirstName + " " + this.state.provider.LastName}</h5>
                                <span>{ this.state.provider.Address1 + " " + this.state.provider.Address2 }</span><br />
                                <span>{ this.state.provider.City + ", " + this.state.provider.State + " " +  this.state.provider.ZipCode }</span>
                            </div>
                        )}
                        </div>
                    </Paper>
                    <br />      
                </div>
                )}
            <br />
            <br />
            <br />
        </div>
        );
  }

};

//export default DocDetailsPage;


const mapDispatchToProps = (dispatch) => {
  return {
 
  }
}


const mapStateToProps = (state) => ({
    searchResults: state.thisApp.searchResults
})


export default connect(
    mapStateToProps,
  mapDispatchToProps
)(ConfirmationPage)


// WEBPACK FOOTER //
// ./src/Pages/Confirmation.js